import { useState, useRef, useEffect } from "react";
import { Outlet } from "react-router";
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import { clsx } from "clsx";

export function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  //const sidebarRef = useRef(null);

  // Close sidebar when clicking outside
  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     // Only close if sidebar is open, and click is NOT inside sidebar
  //     if (
  //     isSidebarOpen &&
  //     sidebarRef.current &&
  //     !sidebarRef.current.contains(event.target))
  //     {
  //       // We generally want to close it if the user clicks "elsewhere".
  //       // Note: This might interfere with interacting with the main content if the sidebar is meant to be persistent.
  //       // But based on user request "click elsewhere to close", we implement this.
  //       // We might want to check if the screen is mobile, but the request was general.
  //       // However, usually for a "Push" sidebar on desktop, you don't auto-close.
  //       // Let's assume the user wants this behavior.

  //       // Refinement: If the click target is the toggle button, we shouldn't double-toggle.
  //       // The toggle button is in the Header. We can't easily detect it here without a ref or ID.
  //       // But usually the toggle button's onClick stops propagation if needed.

  //       // For now, we'll allow it to close.
  //       setIsSidebarOpen(false);
  //     }
  //   }

  //   // Only add listener if sidebar is open
  //   if (isSidebarOpen) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [isSidebarOpen]);

  return (
    <div className="flex min-h-screen bg-slate-50 font-sans text-slate-900 relative">
      {/* Sidebar - Fixed Position */}
      <div
        className={clsx(
          "fixed left-0 top-0 h-full w-64 z-50 transition-transform duration-300 ease-in-out shadow-xl",
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        )}>
        
        <Sidebar isOpen={isSidebarOpen} />
      </div>

      {/* Main Content Wrapper */}
      {/* 
           Added min-w-0 to prevent horizontal overflow when content (like wide tables) tries to expand.
           This forces the flex item to shrink to fit the available space, allowing internal overflow-x-auto to work.
        */}
      <div
        className={clsx(
          "flex flex-1 flex-col transition-all duration-300 ease-in-out min-h-screen min-w-0",
          isSidebarOpen ? "lg:ml-64" : "ml-0"
        )}>
        
        <Header
          title="대시보드 - 2026년 종합 현황"
          onToggleSidebar={(e) => {
            e.stopPropagation(); // Prevent the global click listener from immediately closing it
            setIsSidebarOpen(!isSidebarOpen);
          }} />
        
        
        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-8 relative z-0">
          <Outlet />
        </main>
        
        {/* Mobile Overlay (Backdrop) - Covers entire screen except sidebar when open on mobile */}
        {isSidebarOpen &&
        <div
          className="fixed inset-0 bg-black/20 z-40 lg:hidden"
          aria-hidden="true"
          // The global click listener handles closing, but this visual backdrop also helps.
          // We can keep it or rely on global listener.
        />
        }
      </div>
    </div>);

}